import ActionType from '../action.types'

/*
    Reducer function to push data to the store in case of different schedule action types
*/
let initialstate = { isLoading: false, exercises: [], selected: {} }
export default function schedule_operations(
  state = { ...initialstate },
  action
) {
  switch (action.type) {
    case ActionType.SCHED_INPROGRESS:
      return { ...state, isLoading: action.isLoading }
    case ActionType.SCHED_SET_EXERCISES:
      return { ...state, exercises: action.exercises }
    case ActionType.SCHED_SET_SELECTED:
      return { ...state, selected: action.selected }
    case ActionType.LOGOUT:
      return initialstate
    default:
      return state
  }
}
